export default __webpack_public_path__ + "static/media/18.33f0de1d.png";